import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MetaPixel = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if fbq is already initialized
    if (window.fbq) {
      return;
    }

    // Initialize Facebook Pixel
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;

      // Add error handling for script loading
      t.onerror = () => {
        console.warn('Meta Pixel script failed to load (likely blocked by ad blocker)');
        // Create a mock fbq function to prevent errors
        if (!window.fbq) {
          window.fbq = function () {
            console.log('Meta Pixel blocked - event would have been:', arguments);
          };
          window.fbq.loaded = true;
        }
      };

      t.onload = () => {
        console.log('Meta Pixel script loaded successfully');
      };

      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    // Wait for fbq to be available
    const initPixel = () => {
      if (window.fbq) {
        console.log('Meta Pixel initialized successfully');
        window.fbq('init', '1025095876468009');
        window.fbq('track', 'PageView', {
          page_title: document.title,
          page_location: window.location.href,
          page_path: location.pathname
        });
      } else {
        // Retry after a short delay, but limit retries
        if (initPixel.retryCount < 10) {
          initPixel.retryCount = (initPixel.retryCount || 0) + 1;
          setTimeout(initPixel, 100);
          console.log(`Meta Pixel not initialized, retrying... (${initPixel.retryCount}/10)`);
        } else {
          console.warn(
            'Meta Pixel failed to initialize after 10 retries - likely blocked by ad blocker'
          );
          // Create a mock fbq function to prevent errors
          window.fbq = function () {
            console.log('Meta Pixel blocked - event would have been:', arguments);
          };
          window.fbq.loaded = true;
        }
      }
    };

    initPixel();
  }, []); // Only run once on mount

  // Track page views on route changes (but not on initial load)
  useEffect(() => {
    // Skip the first render to avoid duplicate PageView
    if (window.fbq && location.pathname) {
      window.fbq('track', 'PageView', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname
      });
    }
  }, [location.pathname]); // Only track when pathname changes

  return (
    <>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=1025095876468009&ev=PageView&noscript=1"
          alt=""
        />
      </noscript>
    </>
  );
};

export default MetaPixel;
